<template>
  <div>
    <!-- EDIT DIALOG -->
    <v-dialog v-model="editDialog" persistent max-width="800px" transition="dialog-transition">
      <v-flex class="xs12 ml-0 pl-4 pr-4 pt-4 pb-3 layout row wrap elevation-0 white">
        <v-subheader class="headline ml-0 pl-0 mb-3 black--text">
          <span v-if="editedLocationLog.copy">{{ editedLocationLog.copy.toUpperCase() }}
          </span>
          <span v-if="editedLocationLog.artwork_packing_id">
            - {{ getPacking(editedLocationLog.artwork_packing_id).packing }}
            {{ getPacking(editedLocationLog.artwork_packing_id).colli }}</span>
        </v-subheader>

        <v-flex class="xs12">
          <v-autocomplete v-model="editedLocationLog.artwork_location_id"
            :disabled="editSaving || !!editResult || (c_user.id != 67 && c_user.id != 1)"
            label="New Location" :items="locations" item-text="name" item-value="id" cache-items dense
            clearable></v-autocomplete>
        </v-flex>

        <!-- Reason -->
        <v-flex class="sm12 md6 pr-3">
          <v-text-field v-model="editedLocationLog.reason" :disabled="editSaving || !!editResult"
            name="reason" label="Reason"></v-text-field>
        </v-flex>

        <!-- Shipper -->
        <v-flex class="sm12 md6">
          <v-text-field v-model="editedLocationLog.shipper" :disabled="editSaving || !!editResult"
            name="shipper" label="Shipper"></v-text-field>
        </v-flex>

        <!-- Note -->
        <v-flex class="xs12">
          <v-text-field v-model="editedLocationLog.note" :disabled="editSaving || !!editResult"
            name="note" label="Note"></v-text-field>
        </v-flex>

        <!-- IN OUT -->
        <v-flex class="xs6 mb-0 pl-3 mt-1 pt-3">
          <!-- <v-btn-toggle v-model="toggle" @change="saveField(toggle)">
                    <v-btn small flat v-for="s in f_field.selection" :key="s.id ? s.value : s" class="px-2" :value="s.value">
                      <span> {{s.name}} </span>
                    </v-btn>
                  </v-btn-toggle>             -->
          <v-btn-toggle :disabled="editSaving || !!editResult || (c_user.id != 67 && c_user.id != 1)"
            mandatory v-model="editedLocationLog.storage"
            active-class="activeToggle">
            <v-btn value="in" small flat class="px-3">
              <v-icon small>call_received</v-icon> IN
            </v-btn>
            <v-btn value="out" small flat class="px-3">
              OUT <v-icon small>call_made</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>

        <!-- DATE -->
        <v-flex xs6 d-flex>
          <!-- :return-value.sync="editedLocationLog.change_date" -->
          <v-flex xs12 md6>
            <v-menu v-model="menu2a"
              :disabled="editSaving || !!editResult || (c_user.id != 67 && c_user.id != 1)" ref="menu2a"
              :close-on-content-click="true" :nudge-right="40" lazy landscape transition="scale-transition" offset-y
              full-width min-width="290px">
              <v-text-field v-model="editedLocationLog.change_date" slot="activator" label="Date" prepend-icon="event"
                readonly></v-text-field>
              <v-date-picker persistent color="black" v-model="editedLocationLog.change_date"></v-date-picker>
              <!-- </v-flex> -->
              <!-- @input="save(editedLocationLog.change_date)" -->
              <!-- @input="$refs.menu2.save(editedLocationLog.change_date)" -->
            </v-menu>
          </v-flex>
          <v-flex xs12 md6>
            <v-menu ref="menu" v-model="menu_time" :close-on-content-click="false" :nudge-right="40"
              :return-value.sync="editedLocationLog.change_time" lazy transition="scale-transition" offset-y full-width
              max-width="290px" min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="editedLocationLog.change_time" :disabled="editSaving || !!editResult"
                  label="Picker time if needed"
                  prepend-inner-icon="access_time" readonly v-on="on"></v-text-field>
              </template>
              <v-time-picker v-if="menu_time" v-model="editedLocationLog.change_time" full-width format="24hr"
                @click:minute="$refs.menu.save(editedLocationLog.change_time)"></v-time-picker>
            </v-menu>
          </v-flex>
        </v-flex>

        <!-- COPY -->
        <v-flex xs12 mt-3 mb-0>{{ editedLocationLog.copy }}
          <!-- <v-btn-toggle
                      mandatory
                      v-model="editedLocationLog.copy"
                      active-class="activeToggle"
                    >
                      <v-btn small flat class="px-3" value="artwork">Artwork </v-btn>
                      <v-btn
                        small
                        flat
                        class="px-3"
                        value="packings"
                        :disabled="!artwork.artwork_packings"
                        >Parts
                      </v-btn>
                      <v-btn small flat class="px-3" value="master_physical"
                        >Master Physical
                      </v-btn>
                      <v-btn small flat class="px-3" value="archive_master"
                        >Archive Master
                      </v-btn>
                      <v-btn small flat class="px-3" value="access_copy"
                        >Access Copy
                      </v-btn>
                    </v-btn-toggle> -->
          <!-- <v-icon>call_received</v-icon> -->
          <!-- <v-icon>call_made</v-icon>  -->
          <!-- <v-radio-group v-model="artwork_location_log.storage" row color="black">
                      <v-radio class="mr-4" name="storage" color="black" value="in" label="Storage In"></v-radio>
                      <v-radio class="mr-4" name="storage" color="black" value="out" label="Storage Out"></v-radio>
                    </v-radio-group> -->
        </v-flex>
        <!-- <v-flex class="xs12 mt-0 pt-0">
                    <v-radio-group v-model="artwork_location_log.copy" row>
                      <v-radio name="copy" class="mr-4" color="black" value="artwork" label="Artwork"></v-radio>
                      <v-radio name="copy" class="mr-4" color="black" value="master_physical" label="Master Physical"></v-radio>
                      <v-radio name="copy" class="mr-4" color="black" value="archive_master" label="Archive Master"></v-radio>
                      <v-radio name="copy" class="mr-4" color="black" value="access_copy" label="Access Copy"></v-radio>
                    </v-radio-group>
                  </v-flex> -->

        <!-- :headers="headers" -->
        <!-- <v-data-table
                    v-if="editedLocationLog.copy == 'packings'"
                    :items="artwork.artwork_packings"
                    item-key="id"
                    hide-actions
                    hide-headers
                    class="elevation-0 mx-0 mt-0"
                    style="width: 100%;"
                    v-model="selectedPackings"
                  >
                    <template slot="items" slot-scope="props">
                      <td class="py-2 text-xs-right" style="background-color: #f5f5f5;">
                        <v-checkbox
                          color="black"
                          hide-details
                          v-model="props.selected"
                        ></v-checkbox>
                      </td>
                      <td
                        class="py-2 text-xs-right px-4"
                        style="background-color: #f5f5f5;"
                      >
                        {{ props.item.colli }}
                      </td>
                      <td
                        class="py-2 text-xs-right px-4"
                        style="background-color: #f5f5f5;"
                      >
                        {{ props.item.packing }}
                      </td>
                      <td
                        class="py-1 text-xs-right px-4"
                        style="background-color: #f5f5f5;"
                      >
                        {{ props.item.height }} x {{ props.item.width }} x
                        {{ props.item.lenght }} cm - {{ props.item.weight }} kg
                      </td>
                      <td
                        class="py-2 text-xs-right px-4"
                        style="background-color: #f5f5f5;"
                      >
                        {{ get_location_name(props.item) }}
                      </td>
                      <td
                        class="py-2 text-xs-right px-4"
                        style="background-color: #f5f5f5;"
                      >
                        {{ props.item.contents }}
                      </td>
                      <td
                        class="py-2 text-xs-right px-4"
                        style="background-color: #f5f5f5;"
                      >
                        {{ get_visa_status(props.item) }}
                      </td>
                    </template>
                    <template slot="no-data">
                      <center>No Packings for this artwork.</center>
                    </template>
                  </v-data-table> -->

        <v-flex class="xs12"></v-flex>

        <v-flex v-if="editResult" class="xs12 pa-3 mt-3 grey lighten-4">
          <b>{{ correctionResultTitle(editResult) }}</b>
          <div v-if="editResult.history && editResult.history.id">
            History entry #{{ editResult.history.id }}
            {{ editResult.history.saved ? 'was saved.' : 'was not changed.' }}
          </div>
          <div v-if="editResult.current_state">
            Confirmed current location:
            <b>{{ editResult.current_state.location_name || 'Unknown' }}</b>
            <span v-if="editResult.current_state.changed"> (changed)</span>
            <span v-else> (unchanged)</span>
          </div>
          <div v-if="correctionResultError(editResult)" class="red--text mt-2">
            {{ correctionResultError(editResult) }}
          </div>
        </v-flex>

        <v-flex class="xs12 pr-0 mr-0 mt-3" text-xs-right>
          <template v-if="editResult">
            <v-btn v-if="editResult.status !== 'inconsistent'" small @click="continueEditingCorrection">
              edit again
            </v-btn>
            <v-btn small dark @click="finishEditCorrection">done</v-btn>
          </template>
          <template v-else>
          <v-btn small :disabled="editSaving" @click="finishEditCorrection">cancel</v-btn>
          <!-- !(
                        editedLocationLog.copy == 'packings' &&
                        selectedPackings.length < 1
                      ) && -->
          <v-btn small :dark="
            !(
              editedLocationLog.artwork_location_id == null ||
              editedLocationLog.artwork_location_id == ''
            ) &&
            !(
              editedLocationLog.change_date == null ||
              editedLocationLog.change_date == ''
            )
          " @click="save_edited_artwork_location_log" :loading="editSaving" :disabled="editSaving ||
  editedLocationLog.artwork_location_id == null ||
  editedLocationLog.artwork_location_id == '' ||
  editedLocationLog.change_date == null ||
  editedLocationLog.change_date == ''
">save</v-btn>
          </template>
          <!-- (editedLocationLog.copy == 'packings' ) || -->
          <!-- && selectedPackings.length < 1 -->
        </v-flex>
      </v-flex>
    </v-dialog>

    <v-dialog v-model="deleteDialog" persistent max-width="620px" transition="dialog-transition">
      <v-card>
        <v-card-title class="headline">Delete location history entry?</v-card-title>
        <v-card-text v-if="!deleteResult">
          This removes history entry #{{ deleteLocationLog && deleteLocationLog.id }}.
          The server will reject the deletion if it is the only entry for this artwork/copy/packing stream.
          Otherwise, current location will be recalculated from the latest remaining entry.
        </v-card-text>
        <v-card-text v-else>
          <b>{{ correctionResultTitle(deleteResult) }}</b>
          <div v-if="deleteResult.history">
            History entry #{{ deleteResult.history.id }}
            {{ deleteResult.history.deleted ? 'was deleted.' : 'was not deleted.' }}
          </div>
          <div v-if="deleteResult.current_state">
            Confirmed current location:
            <b>{{ deleteResult.current_state.location_name || 'Unknown' }}</b>
            <span v-if="deleteResult.current_state.changed"> (changed)</span>
            <span v-else> (unchanged)</span>
          </div>
          <div v-if="correctionResultError(deleteResult)" class="red--text mt-2">
            {{ correctionResultError(deleteResult) }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <template v-if="deleteResult">
            <v-btn small dark @click="finishDeleteCorrection">done</v-btn>
          </template>
          <template v-else>
            <v-btn small :disabled="deleteSaving" @click="finishDeleteCorrection">cancel</v-btn>
            <v-btn small color="red" dark :loading="deleteSaving" :disabled="deleteSaving"
              @click="delete_log_action">delete</v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout column class="mt-0">
      <!-- <h3 class="subheading ml-3 mb-2">Current location</h3> -->

      <!-- LOCATION INFO -->
      <v-flex ml-2>
        <!-- <v-flex xs12 v-if="artwork.artwork_location_id"><v-icon>edit_location</v-icon> Artwork: {{lastLocationLogArtwork}} </v-flex> -->

        <!-- LATEST ARTWORK LOCATION -->
        <v-flex xs12 mb-2 v-if="artwork.artwork_location_id">
          <!-- <v-icon small>edit_location</v-icon> -->
          <b>Current Artwork Location</b>
          <v-icon color="red" small class="ml-2">adjust</v-icon>
          <b>{{
            get_location_name(artwork.artwork_location_id)
          }}</b>

          <b class="red--text" v-if="lastLocationLogArtwork && lastLocationLogArtwork.artwork_location_id != artwork.artwork_location_id">
            <br />Current Location of Artwork is different from latest Location History entry.<br>
          </b>
        </v-flex>

        <!-- LATEST ARTWORK LOCATION -->
        <v-flex xs12 v-if="lastLocationLogArtwork">
          <div>
            <b>Latest Artwork Location Change: </b><br>
            <v-icon color="black" small class="mr-1 mt-1">today</v-icon>
            <b>{{ lastLocationLogArtwork.change_date }} </b>
            <v-icon color="red" small class="ml-2">adjust</v-icon>
            {{ get_location_name(lastLocationLogArtwork.artwork_location_id) }}
            <span v-if="lastLocationLogArtwork.storage" class="mr-3 pl-0">
              <v-icon color="black" small class="ml-3">{{
                lastLocationLogArtwork.storage == 'in'
                ? 'call_received'
                : 'call_made'
              }}</v-icon>
              <b>Storage {{ lastLocationLogArtwork.storage.toUpperCase() }}</b>
            </span>
            <span v-if="lastLocationLogArtwork.reason || lastLocationLogArtwork.note">
              ({{ lastLocationLogArtwork.reason }}
              <span v-if="lastLocationLogArtwork.note != lastLocationLogArtwork.reason">{{
                lastLocationLogArtwork.note
              }}</span>)
            </span>
          </div>
        </v-flex>

        <v-flex v-else xs12>
          <v-icon color="black" small class="ml-2">adjust</v-icon>
          <b>{{ get_location_name(artwork.artwork_location_id) }}</b>
        </v-flex>

        <!-- <v-flex xs12 v-if="artwork.artwork_location_id"><v-icon>edit_location</v-icon> Artwork: {{get_location_name(artwork.artwork_location_id)}} </v-flex> -->

        <!-- CURRENT LOCATION OF MASTER PHYSICAL -->
        <v-flex xs12 v-if="lastLocationLogMasterPhysical">
          <v-icon small>edit_location</v-icon>Master Physical
          <v-icon small class="ml-0">adjust</v-icon>
          <b>{{ get_location_name(artwork.master_physical_location_id) }}</b>
          <span v-if="lastLocationLogMasterPhysical.storage">
            <v-icon small class="ml-2">{{
              lastLocationLogMasterPhysical.storage == 'in'
              ? 'call_received'
              : 'call_made'
            }}</v-icon>
            Storage {{ lastLocationLogMasterPhysical.storage.toUpperCase() }}:
          </span>
          <v-icon small class="ml-2">today</v-icon>
          <b>{{ lastLocationLogMasterPhysical.change_date }} </b> ({{
            lastLocationLogMasterPhysical.note
          }})
        </v-flex>

        <!-- CURRENT LOCATION OF ARCHIVE MASTER -->
        <v-flex xs12 v-if="lastLocationLogArchiveMaster">
          <v-icon small>edit_location</v-icon>Archive Master
          <v-icon small class="ml-0">adjust</v-icon>
          <b>{{ get_location_name(artwork.archive_master_location_id) }}</b>
          <span v-if="lastLocationLogArchiveMaster.storage">
            <v-icon small class="ml-2">{{
              lastLocationLogArchiveMaster.storage == 'in'
              ? 'call_received'
              : 'call_made'
            }}</v-icon>
            Storage {{ lastLocationLogArchiveMaster.storage.toUpperCase() }}:
          </span>
          <v-icon small class="ml-2">today</v-icon>
          <b>{{ lastLocationLogArchiveMaster.change_date }}</b>
          ({{ lastLocationLogArchiveMaster.note }})
        </v-flex>

        <!-- CURRENT LOCATION OF ACCESS COPY -->
        <v-flex xs12 v-if="lastLocationLogAccessCopy">
          <v-icon small>edit_location</v-icon>Access Copy
          <v-icon small class="ml-2">adjust</v-icon>
          <b>{{ get_location_name(artwork.access_copy_location_id) }}</b>
          <span v-if="lastLocationLogAccessCopy.storage">
            <v-icon small class="ml-0 pl-0">{{
              lastLocationLogAccessCopy.storage == 'in'
              ? 'call_received'
              : 'call_made'
            }}</v-icon>
            Storage {{ lastLocationLogAccessCopy.storage.toUpperCase() }}:
          </span>
          <v-icon small class="ml-2">today</v-icon>
          {{ lastLocationLogAccessCopy.change_date }} ({{
            lastLocationLogAccessCopy.note
          }})
        </v-flex>

        <!-- CURRENT LOCATION OF PACKINGS -->
        <!-- && lastLocationLogArtwork -->
        <v-flex v-if="artwork.artwork_packings" mt-2 xs12>
          <b>Latest Packing Location Changes: </b>
          <v-flex v-for="p in artwork.artwork_packings" :key="p.id" ml-0 px-0>
            <!-- && p.artwork_location_id != lastLocationLogArtwork.artwork_location_id -->
            <v-flex v-if="p.artwork_location_id" mx-0 px-0>
              <v-icon color="black" small class="mr-1 mt-1">today</v-icon>
              <b>{{ lastLocationLogArtworkPacking(p.id).change_date }} </b>
              <v-icon color="black" small class="mx-1">mdi-archive</v-icon>{{ p.packing }} {{ p.colli }}
              <v-icon color="red" small class="ml-2">adjust</v-icon>
              <b>{{ get_location_name(lastLocationLogArtworkPacking(p.id).artwork_location_id) }}</b>
            </v-flex>
            <v-flex v-else>
              Packing has no location entered.
            </v-flex>
          </v-flex>
        </v-flex>
      </v-flex>

      <v-layout xs12 sm12 md12 mt-2 ml-0 mr-0 px-0>

        <v-flex xs12>
          <v-flex xs12 row layout>
            <!-- ADD NEW LOG / Change current Location -->
            <v-btn class="mt-2 mb-0 ml-1 mr-0" round flat v-if="c_user.edit" @click="switch_change_dialog" small>
              <v-icon small class="mr-1">near_me</v-icon>
              {{
                showUpload ? 'Cancel Changing location' : 'Change current Location'
              }}</v-btn>
            <v-spacer class="pb-0 mb-0"></v-spacer>

            <!-- SHOW LOCATION HISTORY BUTTON -->
            <v-btn small round flat class="pl-3 pr-2 mx-0" @click="showList = !showList">
              {{ showList ? 'Hide' : 'Show' }} History
              <v-icon v-if="!showList" class="pl-3">expand_more</v-icon>
              <v-icon v-if="showList" class="pl-3">expand_less</v-icon>
            </v-btn>
          </v-flex>

          <!-- <span class="text-xs-left mt-2 pt-1 subtitle">
                  
                </span> -->

          <!-- <v-btn class="mt-0 mb-1 ml-0 xs12" v-if="showUpload" @click="showUpload=!showUpload" small>
                  <v-icon left>close</v-icon>Close
                </v-btn> -->
          <!-- c_user.edit && -->

          <!-- CHANGE LOCATION FORM -->
          <v-card v-if="showUpload" class="
                              xs12
                              ml-2
                              mr-0
                              mt-2
                              mb-2
                              elevation-0
                              ">
            <!-- pl-4
                      wrap
                      round
                      row
                      pr-4
                      pt-4
                      layout
                      pb-3
                      white -->
            <v-card-title class="red white--text xs12 py-2">
              <h3>Add Location History Entry and Change Location</h3>
            </v-card-title>

            <v-card-text class="pl-4
                              pr-4
                              pt-3
                              pb-3 wrap row layout">
              <v-flex class="xs12">
                <v-autocomplete :disable="!c_user.edit" v-model="artwork_location_log.artwork_location_id"
                  label="New Location" :items="locations" item-text="name" item-value="id" cache-items clearable
                  persistent-hint
                  :hint="`Latest Artwork Location History entry: ${get_location_name(lastLocationLogArtwork.artwork_location_id)}`"></v-autocomplete>
              </v-flex>
              <!-- <v-flex class="xs12">
                        Latest Artwork Location History entry: {{
                          get_location_name(lastLocationLogArtwork.artwork_location_id)
                        }}
                      </v-flex> -->
              <!-- <v-flex
                    class="xs12"
                    v-if="artwork_location_log.change_date && artwork_location_log.copy"
                  >
                    <v-autocomplete
                      :disable="!c_user.edit"
                      v-model="artwork_location_log.old_location"
                      label="Old Location"
                      :items="locations"
                      item-text="name"
                      item-value="id"
                      cache-items
                      dense
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex v-else>
                    Copy and Change Date must be selected before calculating old
                    Location
                  </v-flex> -->
              <v-flex class="sm12 md6">
                <v-text-field v-model="artwork_location_log.reason" name="reason" label="Reason"
                  class="mr-2"></v-text-field>
              </v-flex>
              <v-flex class="sm12 md6">
                <v-text-field v-model="artwork_location_log.shipper" name="shipper" label="Shipper"></v-text-field>
              </v-flex>
              <v-flex class="xs12">
                <v-text-field v-model="artwork_location_log.note" name="note" label="Note"></v-text-field>
              </v-flex>
              <v-flex class="xs12 sm6 mb-0 pt-3">
                <!-- <v-btn-toggle v-model="toggle" @change="saveField(toggle)">
                    <v-btn small flat v-for="s in f_field.selection" :key="s.id ? s.value : s" class="px-2" :value="s.value">
                      <span> {{s.name}} </span>
                    </v-btn>
                  </v-btn-toggle>             -->
                <v-btn-toggle mandatory v-model="artwork_location_log.storage" active-class="activeToggle">
                  <v-btn value="in" small flat class="px-3">
                    <v-icon small>call_received</v-icon> IN
                  </v-btn>
                  <v-btn value="out" small flat class="px-3">
                    OUT <v-icon small>call_made</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>

              <v-flex xs12 sm6 mb-0 pb-0>
                <v-menu v-model="menu2" :disabled="!c_user.edit" :return-value.sync="artwork_location_log.change_date"
                  ref="menu2" :close-on-content-click="true" :nudge-right="40" lazy landscape
                  transition="scale-transition" offset-y full-width min-width="290px">
                  <v-text-field v-model="artwork_location_log.change_date" slot="activator" label="Date"
                    prepend-inner-icon="event" readonly persistent-hint
                    :hint="this.artwork_location_log.change_date != '' && !shouldUpdateArtworksLocation ? 'A newer movement exists, so current location is expected to remain unchanged.' : ''"></v-text-field>
                  <v-date-picker color="black" persistent v-model="artwork_location_log.change_date"
                    @input="$refs.menu2.save(artwork_location_log.change_date)"></v-date-picker>
                </v-menu>
              </v-flex>
              <!-- {{ artwork_location_log.change_date }} -->
              <!-- <v-spacer></v-spacer> -->
              <!-- <v-flex xs12 class="text-xs-right red--text mt-0 pt-0" v-if="artwork_location_log.change_date != '' && artwork_location_log.change_date <=
                      lastLocationLogArtwork.change_date">
                        Date is before or the same as the last change, artwork location will not be updated.</v-flex> -->

              <!-- COPY -->
              <v-flex xs12 mt-3 mb-0>
                <v-btn-toggle flat mandatory v-model="artwork_location_log.copy" active-class="activeToggle">
                  <v-btn v-if="artwork.artwork_packings.length > 0" small flat class="px-2" value="packings"
                    :disabled="artwork.artwork_packings.length == 0">Parts
                  </v-btn>
                  <v-btn small flat class="px-2" value="artwork" v-if="artwork.artwork_packings.length == 0">Artwork
                  </v-btn>
                  <v-btn small flat class="px-2" value="master_physical">Master Physical
                  </v-btn>
                  <v-btn small flat class="px-2" value="archive_master">Archive Master
                  </v-btn>
                  <v-btn small flat class="px-2" value="access_copy">Access Copy
                  </v-btn>
                  <!-- <v-icon>call_received</v-icon> -->
                  <!-- <v-icon>call_made</v-icon>  -->
                </v-btn-toggle>
                <!-- <v-radio-group v-model="artwork_location_log.storage" row color="black">
                      <v-radio class="mr-4" name="storage" color="black" value="in" label="Storage In"></v-radio>
                      <v-radio class="mr-4" name="storage" color="black" value="out" label="Storage Out"></v-radio>
                    </v-radio-group> -->
              </v-flex>
              <!-- <v-flex class="xs12 mt-0 pt-0">
                    <v-radio-group v-model="artwork_location_log.copy" row>
                      <v-radio name="copy" class="mr-4" color="black" value="artwork" label="Artwork"></v-radio>
                      <v-radio name="copy" class="mr-4" color="black" value="master_physical" label="Master Physical"></v-radio>
                      <v-radio name="copy" class="mr-4" color="black" value="archive_master" label="Archive Master"></v-radio>
                      <v-radio name="copy" class="mr-4" color="black" value="access_copy" label="Access Copy"></v-radio>
                    </v-radio-group>
                  </v-flex> -->

              <!-- TABLE OF PACKINGS -->
              <!-- :headers="headers" -->
              <v-flex v-if="artwork_location_log.copy == 'packings'" pa-0 ma-0 d-flex>
                <v-checkbox label="Change All Parts" color="black" v-model="changeAllParts"></v-checkbox>
                <v-checkbox label="Change Also Artwork Location" color="black"
                  v-model="changeArtworkLocation"></v-checkbox>
              </v-flex>
              <v-data-table v-if="artwork_location_log.copy == 'packings'" :items="artwork.artwork_packings" item-key="id"
                hide-actions hide-headers class="elevation-0 mx-0 mt-0" style="width: 100%" v-model="selectedPackings">
                <template slot="items" slot-scope="props">
                  <tr>
                    <td class="py-2 text-xs-left px-0">
                      <v-container grid-list-xs text-xs-left pa-0>
                        <v-layout row wrap>
                          <!-- <v-flex xs12> -->

                          <v-flex xs1>
                            <v-checkbox class="pa-0" color="black" hide-details v-model="props.selected"></v-checkbox>
                          </v-flex>

                          <v-flex xs6 pr-2 style="font-weight: bold; overflow: auto">
                            {{ props.item.colli }}<br />
                            {{ props.item.packing }}
                          </v-flex>

                          <v-flex xs5 px-1>
                            {{ props.item.height }} x {{ props.item.width }} x
                            {{ props.item.lenght }} cm <br />
                            {{ props.item.weight }} kg
                          </v-flex>

                          <v-flex xs1> </v-flex>

                          <v-flex xs6 pr-2 style="overflow: hidden">
                            {{ get_location_name(props.item.artwork_location_id) }}
                            <br />
                            {{ get_visa_status(props.item.visa_status) }}
                          </v-flex>

                          <v-flex xs5 px-1 style="overflow: hidden">
                            {{ props.item.contents }}
                          </v-flex>

                          <!-- </v-flex> -->
                        </v-layout>
                      </v-container>
                    </td>
                  </tr>
                </template>
                <template slot="no-data">
                  <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                  <center>No Packings for this artwork.</center>
                </template>
              </v-data-table>

              <v-flex class="xs12"></v-flex>
              <v-flex class="xs12 pr-0 mr-0 mt-3" text-xs-right>
                <v-btn @click="switch_change_dialog" small flat>cancel</v-btn>
                <!-- :dark="!(artwork_location_log.artwork_location_id == null || artwork_location_log.artwork_location_id == '') &&
                        !(
                          artwork_location_log.copy == 'packings' &&
                          selectedPackings.length < 1
                        )
                      " -->
                <!-- flat color="black" -->
                <v-btn small :dark="
                  !(
                    artwork_location_log.artwork_location_id == null ||
                    artwork_location_log.artwork_location_id == ''
                  ) &&
                  !(
                    artwork_location_log.copy == 'packings' &&
                    selectedPackings.length < 1
                  ) &&
                  !(
                    artwork_location_log.change_date == null ||
                    artwork_location_log.change_date == ''
                  )
                " @click="showSaveDialog" :disabled="
  artwork_location_log.artwork_location_id == null ||
  artwork_location_log.artwork_location_id == '' ||
  (artwork_location_log.copy == 'packings' &&
    selectedPackings.length < 1) ||
  artwork_location_log.change_date == null ||
  artwork_location_log.change_date == ''
">save</v-btn>
              </v-flex>
            </v-card-text>
          </v-card>

          <v-dialog v-model="saveDialog" scrollable persistent :overlay="true" max-width="500px"
            transition="dialog-transition">
            <v-card>
              <v-card-title primary-title class="red white--text pb-2 pt-2">
                <h2>{{ movementResults.length > 0 ? 'Confirmed Result' : 'Review Changes' }}</h2>
              </v-card-title>
              <v-card-text v-if="movementResults.length == 0 && (artwork_location_log.copy != 'packings' || changeArtworkLocation)">
                <h3 class="mb-3"> New Location History entry will be created for:<br> <span class="text-uppercase">{{
                  artwork.title
                }}, {{ artwork.accession_number }}
                </span></h3>
                <div>
                  Change Date: <b>{{ artwork_location_log.change_date }}</b>
                  <span v-if="lastLocationLogForPreview">
                    (latest {{ previewCopyLabel }} entry: {{ lastLocationLogForPreview.change_date }})
                  </span>
                </div>
                <div>
                  Location: <b>{{ get_location_name(artwork_location_log.artwork_location_id) }}</b>
                </div>
                <h3 v-if="shouldUpdatePreviewCurrentLocation">
                  {{ previewCopyLabel }} current location is expected to change.</h3>
                <h3 v-else class="red--text">
                  {{ previewCopyLabel }} current location is expected to remain unchanged because a newer location
                  history entry exists. The server response will confirm the resulting state.</h3>
              </v-card-text>

              <v-card-text v-if="movementResults.length == 0 && selectedPackings.length > 0">
                <h3 class="pb-2"> New Location History entry will be created for these Packings:</h3>

                <div v-for="sp in selectedPackings" class="py-2">
                  <b>{{ sp.colli }}</b>
                  <span v-if="shouldUpdatePackingCurrentLocation(sp.id)">
                    => {{ get_location_name(artwork_location_log.artwork_location_id) }}
                  </span>
                  <span v-else class="red--text">
                    This packing's current location will <b>NOT</b> be changed, because a location
                    history entry  with newer Change Date exists.
                  </span>
                  <v-divider class="mt-2"></v-divider>
                </div>
                <div>
                  Change Date: <b>{{ artwork_location_log.change_date }}</b>
                </div>
                <!-- <div>
                          Location: <b>{{ get_location_name(artwork_location_log.artwork_location_id) }}</b>
                        </div> -->
              </v-card-text>
              <v-card-text v-if="movementResults.length > 0" class="pt-0">
                <v-alert
                  :value="true"
                  :type="allMovementResultsComplete ? 'success' : 'warning'"
                  outline
                >
                  Server-confirmed result{{ movementResults.length > 1 ? 's' : '' }}
                </v-alert>
                <div v-for="(result, index) in movementResults" :key="`movement-result-${index}`" class="py-2">
                  <b>{{ result.target_label }}</b><br>
                  <span v-if="result.history && result.history.saved">
                    History entry #{{ result.history.id }} was saved.
                  </span>
                  <span v-else class="red--text">History was not saved.</span><br>
                  <span v-if="result.current_state">
                    Confirmed current location:
                    <b>{{ result.current_state.location_name || get_location_name(result.current_state.location_id) || 'None' }}</b>.
                    <span v-if="result.current_state.changed"> Current state changed.</span>
                    <span v-else-if="result.current_state.reason == 'newer_movement_exists'">
                      Current state stayed unchanged because a newer movement exists.
                    </span>
                    <span v-else-if="result.current_state.reason == 'already_at_destination'">
                      It was already at this location.
                    </span>
                  </span>
                  <div v-if="result.status != 'complete'" class="red--text mt-1">
                    {{ movementResultError(result) }}
                  </div>
                  <v-divider v-if="index < movementResults.length - 1" class="mt-2"></v-divider>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <template v-if="movementResults.length == 0">
                  <v-btn color="cancel" small gray @click="saveDialog = false" :disabled="movementSaving">cancel</v-btn>

                  <v-btn small :loading="movementSaving" :dark="
                  !(
                    artwork_location_log.artwork_location_id == null ||
                    artwork_location_log.artwork_location_id == ''
                  ) &&
                  !(
                    artwork_location_log.copy == 'packings' &&
                    selectedPackings.length < 1
                  ) &&
                  !(
                    artwork_location_log.change_date == null ||
                    artwork_location_log.change_date == ''
                  )
                " @click="save_artwork_location_log" :disabled="
  artwork_location_log.artwork_location_id == null ||
  artwork_location_log.artwork_location_id == '' ||
  (artwork_location_log.copy == 'packings' &&
    selectedPackings.length < 1) ||
  artwork_location_log.change_date == null ||
  artwork_location_log.change_date == '' ||
  movementSaving
">save</v-btn>
                </template>
                <template v-else>
                  <v-btn v-if="canChangeMovementAfterResult" small flat @click="editMovementAfterResult">change details</v-btn>
                  <v-btn small flat @click="startAnotherMovement" :disabled="!allMovementResultsComplete">new movement</v-btn>
                  <v-btn small dark @click="finishMovementDialog">close</v-btn>
                </template>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-spacer></v-spacer>

          <!-- LOCATION HISTORY  -->
          <v-flex mt-0 d-flex text-xs-right v-if="
            (artwork.artwork_location_logs &&
              artwork.artwork_location_logs.length > 0) ||
            (artwork.location_history && !showUpload)
          ">
            <v-spacer></v-spacer>

            <!-- LOCATION HISTORY FILTER -->
            <span v-if="showList" class="mt-0 mr-0">
              <v-menu offset-y :close-on-content-click="true" class="text-xs-right mx-0">

                <template v-slot:activator="{ on }">
                  <v-btn small round flat v-on="on" class="text-xs-right mx-0 mt-0 my-0 py-0 px-3">
                    <span class="text-uppercase mr-3">{{ selectedFilter }}</span>
                    <v-icon small>filter_list</v-icon>
                  </v-btn>
                </template>

                <v-list value="artwork">
                  <v-list-tile v-for="(item, index) in [
                    'artwork',
                    'packings',
                    'master_physical',
                    'archive_master',
                    'access_copy',
                  ]" :key="index.id" @click="toggleCopyFilter(item)">
                    <v-list-tile-title>{{ item }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>

              </v-menu>

              <!-- Filter by Packing -->
              <span v-if="selectedFilter == 'packings'" class="mt-0 mr-0">
                <v-menu offset-y :close-on-content-click="true" class="text-xs-right mx-0">

                  <template v-slot:activator="{ on }">
                    <v-btn flat small round v-on="on" class="text-xs-right mx-0 px-3">
                      <span class="text-uppercase mr-3">Filter by Packing: {{
                        selectedPackingFilter != 'all' ? selectedPackingFilter.colli : 'all' }}</span>
                      <v-icon small>inventory_2</v-icon>
                    </v-btn>
                  </template>

                  <v-list :value="artwork.artwork_packings[0]">
                    <v-list-tile key="all" @click="togglePackingFilter('all')">
                      <v-list-tile-title>all</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-for="(item, index) in artwork.artwork_packings" :key="index.id"
                      @click="togglePackingFilter(item)">
                      <v-list-tile-title>{{ item.colli }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </span>
            </span>

          </v-flex>
        </v-flex>
      </v-layout>

      <!-- LIST OF LOGS -->
      <!-- c_user.edit && -->
      <v-flex row xs12 sm12 md12 mt-0 ml-1 mr-0 v-if="showList">
        <v-list class="xs12 py-0 grey lighten-4" three-line v-if="
          (artwork.artwork_location_logs &&
            artwork.artwork_location_logs.length > 0) ||
          (artwork.location_history && artwork.id < 2352)
        ">
          <v-flex my-0 pb-0 pt-2>
            <template v-for="l in filtered_artwork_location_logs">
              <!-- <v-divider :key="`divider_${l.id}`"></v-divider> -->
              <v-flex :key="l.id">
                <v-flex px-3 py-0>
                  <v-list-tile-title class="subheading font-weight-bold">
                    <span v-if="l.storage_out">{{ l.storage_out }}</span>
                    <span v-if="l.storage_in">{{ l.storage_in }}</span>
                    <span v-if="!l.storage_in && !l.storage_out">{{
                      l.change_date
                    }}</span>
                    <span v-if="
                      l.storage_in == null &&
                      l.storage_out == null &&
                      l.change_date == null
                    " class="red--text">NO DATE</span>

                    <span v-if="l.storage">{{ l.copy.toUpperCase() }}
                      {{ l.storage.toUpperCase() }}</span>
                    <span v-if="l.artwork_packing_id">({{ getPacking(l.artwork_packing_id).packing }}
                      {{ getPacking(l.artwork_packing_id).colli }})</span>
                    <small class="right font-weight-thin">
                      <span v-if="l.created_by != null">{{ get_abb(l.created_by) }} -</span>
                      <span v-if="l.created_at != null || l.created_at != ''">{{
                        format_date(l.created_at)
                      }}</span>
                    </small>
                  </v-list-tile-title>

                  <!-- class="body-2" -->
                  <!-- style="height: 30px; line-height: 1.2; padding-top: 5px" -->
                  <v-list-tile-title>
                    <!-- <span class="">FROM:</span> -->

                    <span class="right" v-if="c_user.edit">
                      <v-btn @click="delete_log(l)" small icon class="mt-0">
                        <v-icon small color="red">delete</v-icon></v-btn>
                      <v-btn :key="l.id + 'b'" small class="mr-0 mt-0" icon @click="editLocation(l)">
                        <v-icon small color="black">edit</v-icon>
                      </v-btn>
                    </span>

                    <!-- <span v-if="l.old_location"
                              >{{ get_location_name(l.old_location) }}
                            </span> -->
                    <span v-else-if="
                      l.note == 'Created at Artwork record creation in CMS'
                    ">
                      Created at Artwork record creation in CMS
                    </span>
                    <!-- <span v-if="!l.old_location">
                              {{ get_old_location(l) }}
                              <br />
                            </span> -->
                    <!-- <span v-else class="red--text">no location entered</span> -->

                    <span class="">TO:</span>
                    {{ get_location_name(l.artwork_location_id) }}
                  </v-list-tile-title>

                  <v-list-tile-sub-title class="body-2" v-if="l.reason">
                    <span class="">REASON:</span>
                    {{ l.reason }}
                  </v-list-tile-sub-title>

                  <!-- <v-list-tile-title class="body-2" v-if="l.location_history_authoriser">
                            <span class="text--primary">Authoriser:</span>
                            {{ l.location_history_authoriser }}
                          </v-list-tile-title> -->

                  <v-list-tile-sub-title class="body-2" v-if="
                    l.note &&
                    l.note != 'Created at Artwork record creation in CMS'
                  ">
                    <span class="">NOTE:</span>
                    {{ l.note }}
                  </v-list-tile-sub-title>

                  <v-list-tile-sub-title class="body-2" v-if="l.shipper">
                    <span class="">SHIPPER:</span>
                    {{ l.shipper }}
                  </v-list-tile-sub-title>
                </v-flex>
                <!-- (Added {{l.change_date}} by {{l.created_by}}) -->
                <!-- <v-list-tile-action><v-btn @click="delete_log" icon ><v-icon>delete</v-icon></v-btn></v-list-tile-action> -->
              </v-flex>
              <v-divider class="my-2" :key="`a${l.id}`"></v-divider>
            </template>
          </v-flex>
        </v-list>
        <v-flex v-html="nl2br(artwork.location_history)" class="ml-3 mt-3 pa-0"
          v-if="artwork.location_history && artwork.id < 2352">
        </v-flex>
      </v-flex>
      <!-- <v-divider class="mt-4 black ml-3 mr-2"></v-divider> -->
    </v-layout>
  </div>
</template>

<script>
import axios from '@/utils/apiClient'
import { serverBus } from '../../main'

function dynamicSort(property, property2) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    if (a[property] > b[property]) return 1
    if (a[property] < b[property]) return -1
    if (a[property2] && b[property2]) {
      if (a[property2] > b[property2]) return 1
      if (a[property2] < b[property2]) return -1
    }
    return result * sortOrder
  }
}

export default {
  props: ['artwork'],
  data: () => ({
    saveDialog: false,
    selectedFilter: 'artwork',
    selectedPackingFilter: 'all',
    // historyFilter: 'artwork',
    changeArtworkLocation: false,
    changeAllParts: false,
    editDialog: false,
    editSaving: false,
    editResult: null,
    deleteDialog: false,
    deleteLocationLog: null,
    deleteSaving: false,
    deleteResult: null,
    menu_time: false,
    time: null,
    editedLocationLog: {},
    selectedPackings: [],
    menu2: false,
    menu2a: false,
    showUpload: false,
    showList: false,
    show: false,
    errors: '',
    movementSaving: false,
    movementResults: [],
    artwork_location_log: {
      created_by: '',
      storage: 'in',
      note: '',
      change_date: '',
      artwork_location_id: '',
      copy: 'artwork',
      artwork_packing_id: '',
      shipper: '',
      reason: '',
    },
  }),
  computed: {
    old_location_from_date_and_copy() {
      // var current = { change_date: this.artwork_location_log.change_date, copy: this.artwork_location_log.copy, artwork_id: this.artwork.id }
      if (
        this.artwork_location_log.change_date &&
        this.artwork_location_log.copy
      ) {
        // this.artwork_location_log.old_location = this.get_old_location(current)
        if (this.artwork_location_log.copy == 'packings') {
          this.artwork_location_log.artwork_id = ''
          return 'Previous Location cannot be calculated for packings'
        } else if (
          ['artwork', 'master_physical', 'archive_master'].includes(
            this.artwork_location_log.copy
          )
        ) {
          this.artwork_location_log.artwork_id = this.artwork.id
          var olderArtworkLogs = this.sorted_artwork_location_logs.filter(
            (l) =>
              l.copy == this.artwork_location_log.copy &&
              l.change_date < this.artwork_location_log.change_date
          )
          console.log(olderArtworkLogs)
          if (olderArtworkLogs.length > 1) {
            // var indexOfcurrent = this.findPositionByAtribute(artworkLogs,'this.artwork_location_log')
            var previous = olderArtworkLogs[0]
            if (previous) {
              this.artwork_location_log.old_location =
                previous.artwork_location_id
              return previous.artwork_location_id
            } else {
              this.artwork_location_log.old_location = 465
              return 465
            }
          } else {
            this.artwork_location_log.old_location = 465
            return 465
          }
        }
      } else {
        return 'Copy and Change Date must be selected before calculating old Location'
      }
    },
    sorted_artwork_location_logs() {
      return this.artwork.artwork_location_logs
        .sort(dynamicSort('change_date', 'change_time'))
        .reverse()
    },
    filtered_artwork_location_logs() {
      var o = this.sorted_artwork_location_logs.filter(
        (l) => l.copy == this.selectedFilter
      )
      console.log(this.selectedPackingFilter)
      console.log(o)
      if (this.selectedPackingFilter != 'all') {
        console.log('this.selectedPackingFilter')
        console.log(this.selectedPackingFilter.id)
        o = o.filter((l) => l.artwork_packing_id == this.selectedPackingFilter.id)
      }
      console.log(o)
      return o
    },
    locations() {
      return Object.assign([], this.$store.getters.enabled_locations).sort(
        dynamicSort('name')
      )
    },
    lastLocationLogArtwork() {
      return this.getLastLog(this.artwork.artwork_location_logs, 'artwork')
    },
    lastLocationLogMasterPhysical() {
      return this.getLastLog(
        this.artwork.artwork_location_logs,
        'master_physical'
      )
    },
    lastLocationLogArchiveMaster() {
      return this.getLastLog(
        this.artwork.artwork_location_logs,
        'archive_master'
      )
    },
    lastLocationLogAccessCopy() {
      return this.getLastLog(this.artwork.artwork_location_logs, 'access_copy')
    },
    shouldUpdateArtworksLocation () {
      return this.shouldUpdatePreviewCurrentLocation
    },
    lastLocationLogForPreview() {
      const copy = this.artwork_location_log.copy === 'packings'
        ? 'artwork'
        : this.artwork_location_log.copy
      return this.getLastLog(this.artwork.artwork_location_logs, copy) || null
    },
    shouldUpdatePreviewCurrentLocation() {
      return this.movementWouldBeLatest(this.lastLocationLogForPreview)
    },
    previewCopyLabel() {
      const copy = this.artwork_location_log.copy === 'packings'
        ? 'artwork'
        : this.artwork_location_log.copy
      return (copy || 'artwork').split('_').join(' ')
    },
    allMovementResultsComplete() {
      return this.movementResults.length > 0 &&
        this.movementResults.every(result => result.status === 'complete')
    },
    canChangeMovementAfterResult() {
      return this.movementResults.length > 0 &&
        this.movementResults.every(result =>
          ['rejected', 'failed'].includes(result.status) &&
          (!result.history || !result.history.saved)
        )
    },
  },
  watch: {
    changeAllParts: function () {
      this.selectAllParts()
    },
    artwork_location_log: {
      handler(val) {
        console.log('watch')
        if (this.artwork_location_log.change_date) {
          this.artwork_location_log.old_location ==
            this.old_location_from_date_and_copy
        }
      },
      deep: true,
    },
  },
  methods: {
    movementWouldBeLatest(lastLog) {
      if (!lastLog) return true
      if (this.artwork_location_log.change_date > lastLog.change_date) return true
      if (this.artwork_location_log.change_date < lastLog.change_date) return false

      const proposedTime = this.artwork_location_log.change_time || ''
      const lastTime = lastLog.change_time || ''
      return proposedTime >= lastTime
    },
    shouldUpdatePackingCurrentLocation(id) {
      return this.movementWouldBeLatest(this.lastLocationLogArtworkPacking(id))
    },
    lastLocationLogArtworkPacking(id) {
      return this.getLastLog(this.artwork.artwork_location_logs, 'packings', id)
    },
    switch_change_dialog() {
      this.showUpload = !this.showUpload
      if (this.showUpload) {
        this.artwork_location_log.old_location =
          this.old_location_from_date_and_copy
      }
    },
    // get_old_location_from_date_and_copy() {
    //   // var current = { change_date: this.artwork_location_log.change_date, copy: this.artwork_location_log.copy, artwork_id: this.artwork.id }
    //   if(this.artwork_location_log.change_date && this.artwork_location_log.copy) {
    //     // this.artwork_location_log.old_location = this.get_old_location(current)
    //     if (this.artwork_location_log.copy == 'packings') {
    //         return 'Previous Location cannot be calculated for packings'
    //     } else if (['artwork','master_physical','archive_master'].includes(this.artwork_location_log.copy)) {
    //       var olderArtworkLogs = this.sorted_artwork_location_logs
    //         .filter(l => l.artwork_id = this.artwork_location_log.artwork_id
    //           && l.copy == this.artwork_location_log.copy
    //           && l.change_date < this.artwork_location_log.change_date)
    //       if (olderArtworkLogs.length > 1) {
    //         // var indexOfcurrent = this.findPositionByAtribute(artworkLogs,'this.artwork_location_log')
    //         var previous = olderArtworkLogs[0]
    //         if(previous) {
    //           this.artwork_location_log.old_location = previous.artwork_location_id
    //           return  previous.artwork_location_id
    //         } else {
    //           return 'no previous log for this packing'
    //         }
    //       } else {
    //         return 'no previous log for this packing'
    //       }
    //     }
    //   } else {
    //     return 'Copy and Change Date must be selected before calculating old Location'
    //   }
    // },
    get_old_location(log) {
      if (log.copy == 'packings') {
        var packingLogs = this.sorted_artwork_location_logs.filter(
          (l) => (l.artwork_packing_id = log.artwork_packing_id)
        )
        if (packingLogs.length > 1) {
          var indexOfcurrent = packingLogs.indexOf(log)
          var previous = packingLogs[indexOfcurrent + 1]
          return previous
            ? this.get_location_name(previous.artwork_location_id)
            : 'no previous log for this packing'
        } else {
          return 'no previous log for this packing'
        }
      } else if (
        ['artwork', 'master_physical', 'archive_master'].includes(log.copy)
      ) {
        var artworkLogs = this.sorted_artwork_location_logs.filter(
          (l) => (l.artwork_id = log.artwork_id && l.copy == log.copy)
        )
        if (artworkLogs.length > 1) {
          var indexOfcurrent = artworkLogs.indexOf(log)
          var previous = artworkLogs[indexOfcurrent + 1]
          return previous
            ? this.get_location_name(previous.artwork_location_id)
            : 'no previous log for this packing'
        } else {
          return 'no previous log for this packing'
        }
      }
      // artwork_location_id
    },
    toggleCopyFilter(c) {
      console.log(c)
      this.selectedFilter = c
      if (c == 'packings') {
        this.selectedPackingFilter = 'all'
      }
    },
    togglePackingFilter(c) {
      this.selectedPackingFilter = c
    },
    selectAllParts() {
      if (this.changeAllParts) {
        this.artwork.artwork_packings.forEach((p) => {
          if (!this.selectedPackings.includes(p)) {
            this.selectedPackings.push(p)
          }
        })
      } else {
        this.selectedPackings = []
      }
    },
    getLastLog(logs, copy, id) {
      if (copy == 'packings') {
        if (logs && logs.length > 0) {
          var out = logs
            .filter((ll) => ll.artwork_packing_id === id)
            .sort(function (a, b) {
              if (a.change_date > b.change_date) {
                return -1
              }
              if (a.change_date < b.change_date) {
                return 1
              }
              return 0
            })[0]
          if (out) {
            return out
          } else {
            return ''
          }
        } else {
          return ''
        }
      } else {
        if (logs && logs.length > 0) {
          var out = logs
            .filter((ll) => ll.copy === copy)
            .sort(function (a, b) {
              if (a.change_date > b.change_date) {
                return -1
              }
              if (a.change_date < b.change_date) {
                return 1
              }
              return 0
            })[0]
          if (out) {
            return out
          } else {
            return ''
          }
        } else {
          return ''
        }
      }
    },
    getPacking(id) {
      console.log(id)
      console.log(this.artwork.artwork_packings)
      // get an array of all ids in this.artwork.artwork_packings
      var ids = this.artwork.artwork_packings.map(p => p.id)
      // check if id is in the array
      if (ids.includes(id)) {
        // if yes, return the packing
        return this.artwork.artwork_packings.find(p => p.id === id)
      } else {
        // if not, return empty packing
        return { packing: 'Not existing packing.', colli: 'Deleted?' }
      }
      // return this.artwork.artwork_packings.find((ap) => ap.id === id)
    },
    editLocation(l) {
      this.editedLocationLog = { ...l }
      this.editResult = null
      this.editDialog = true
    },
    // location_name (id) {
    //   // console.log(id)
    //   if (id > 0) {
    //     var a = this.$store.state.locations.find(l => l.id === id)
    //     if (a) {
    //       return a.name
    //     } else {
    //       return 'Location not found in CMS.'
    //     }
    //   } else {
    //     return 'Location not found in CMS.'
    //   }
    // },
    download() { },
    delete_log(item) {
      this.deleteLocationLog = item
      this.deleteResult = null
      this.deleteDialog = true
    },
    async delete_log_action() {
      if (!this.deleteLocationLog) return

      this.deleteSaving = true
      serverBus.$emit('showSnackbar', 'Deleting Location history.', 'black')
      const url = `${this.$globals.apiserver}/artwork_location_logs/${this.deleteLocationLog.id}.json`

      try {
        const response = await axios.delete(url)
        this.deleteResult = response.data
        this.applyConfirmedCorrection(response.data)
        serverBus.$emit('showSnackbar', 'Location history correction confirmed.', 'green')
      } catch (error) {
        this.deleteResult = this.correctionErrorResponse(error)
        serverBus.$emit('showSnackbar', 'Location history entry was not deleted.', 'red')
      } finally {
        this.deleteSaving = false
        this.$emit('getArtwork')
      }
    },
    finishDeleteCorrection() {
      if (this.deleteSaving) return
      this.deleteDialog = false
      this.deleteLocationLog = null
      this.deleteResult = null
    },
    showSaveDialog() { this.saveDialog = true },
    // save_artwork_location_log() {
    //   this.saveDialog = false
    //   // console.log('save_artwork_location_log')
    //   serverBus.$emit('showSnackbar', `Saving Location History Entry…`, 'green')

    //   // NASETUJEM LOG BASICS
    //   this.artwork_location_log.created_by = this.c_user.id
    //   this.artwork_location_log.artwork_id = this.artwork.id
    //   this.artwork_location_log.location_id = this.artwork_location_log.artwork_location_id

    //   if (this.artwork_location_log.storage === 'in') {
    //     this.artwork_location_log.storage_in = this.artwork_location_log.change_date
    //   } else {
    //     this.artwork_location_log.storage_out = this.artwork_location_log.change_date
    //   }
  
    //   // ZMENIM LOGS ARTWORKU NA POLE, AK BOLO NULL, ABY SOM MOHOL OD NEHO PRIDAVAT
    //   if (!this.artwork.artwork_location_logs) {
    //     this.artwork.artwork_location_logs = []
    //   }

    //   // this.all_artwork_location_logs.push(this.artwork_location_log)

    //   // IF I AM CHANGING PACKINGS - MUST BE SOME SELECTED
    //   if (
    //     this.artwork_location_log.copy === 'packings' &&
    //     this.selectedPackings &&
    //     this.selectedPackings.length > 0
    //   ) {

    //     // FOR EACH PACKING CREATE LOG AND CHANGE ITS LOCATION
    //     for (const sp in this.selectedPackings) {
    //       // console.log(this.selectedPackings[sp].id)
    //       this.artwork_location_log.artwork_packing_id = this.selectedPackings[sp].id

    //       // ADD LOG FOR THIS PACKING - PACKING ITSELF IS CHANGED ON THE SERVER
    //       // console.log(this.artwork_location_log)
    //       axios
    //         .post(`${this.$globals.apiserver}/artwork_location_logs.json`, {
    //           artwork_location_log: this.artwork_location_log,
    //         })
    //         .then((response) => {
    //           this.errors = {}
    //           // this.artwork.artwork_location_logs.push(response.data);
    //           // @artwork.artwork_location_id = @artwork_location_log.id
    //           // elsif @artwork_location_log.copy = 'master_physical'
    //           // @artwork.master_physical_location_id = @artwork_location_log.id
    //           // elsif @artwork_location_log.copy = 'archive_master'
    //           // @artwork.archive_master_location_id = @artwork_location_log.id
    //           // elsif @artwork_location_log.copy = 'access_copy'
    //           // @artwork.access_copy_location_id = @artwork_location_log.id
    //           // this.active_artwork_location_logs = this.artwork.artwork_location_logs
    //           // this.$store.commit('ADD_LOG', response.data)
    //           // this.active_artwork_location_logs = this.$store.state.artwork_location_logs
    //           this.showUpload = !this.showUpload
    //         })
    //         .catch((error) => {
    //           console.log(error)
    //           // this.errors = error.response.data;
    //         })
    //       this.artwork_location_log.artwork_packing_id = null
    //     }

    //     // IF ALSO ARTWORK LOCATION IS SELECTED TO BE CHANGED
    //     if (this.changeArtworkLocation) {
    //       // console.log('changeArtworkLocation')

    //       // SAVE NEW ARTWORK LOCATION - only if change_date is later than latest log
    //       if (this.artwork_location_log.change_date > this.lastLocationLogArtwork.change_date) {
    //         // console.log(this.artwork_location_log.change_date)
    //         // console.log(this.lastLocationLogArtwork.change_date)
    //         axios
    //           .put(
    //             `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`,
    //             {
    //               artwork: {
    //                 artwork_location_id:
    //                   this.artwork_location_log.artwork_location_id,
    //               },
    //             }
    //           )
    //           .then((response) => {
    //             console.log('changeArtworkLocation response change artwork')

    //             this.errors = {}
    //             this.artwork.artwork_location_logs.push(response.data)

    //             // ON SAVE SUCCESS SET CURRENT ARTWORK'S LOCATION TO NEW LOCATION
    //             // if (this.artwork_location_log.copy === 'artwork') {
    //             //   this.artwork.artwork_location_id = this.artwork_location_log.artwork_location_id
    //             // } else if (this.artwork_location_log.copy === 'master_physical') {
    //             //   this.artwork.master_physical_location_id = this.artwork_location_log.artwork_location_id
    //             // } else if (this.artwork_location_log.copy === 'archive_master') {
    //             //   this.artwork.archive_master_location_id = this.artwork_location_log.artwork_location_id
    //             // } else if (this.artwork_location_log.copy === 'access_copy') {
    //             //   this.artwork.access_copy_location_id = this.artwork_location_log.artwork_location_id
    //             // }
    //             // this.$store.commit('ADD_LOG', response.data)
    //             // this.active_artwork_location_logs = this.$store.state.artwork_location_logs
    //             this.changeArtworkLocation = false
    //           })
    //       }

    //       // ADD LOG FOR ARTWORK
    //       this.artwork_location_log.copy = 'artwork'
    //       axios
    //         .post(`${this.$globals.apiserver}/artwork_location_logs.json`, {
    //           artwork_location_log: this.artwork_location_log,
    //         })
    //         .then((response) => {
    //           console.log('changeArtworkLocation response add log')

    //           this.errors = {}
    //           this.artwork.artwork_location_logs.push(response.data)
    //           this.artwork.artwork_location_id = this.artwork_location_log.artwork_location_id
    //           this.$store.commit('ADD_LOG', response.data)
    //           this.active_artwork_location_logs = this.$store.state.artwork_location_logs
    //           // this.showUpload = !this.showUpload
    //           this.artwork_location_log = {
    //             created_by: this.c_user.id,
    //             storage: 'in',
    //             note: '',
    //             change_date: '',
    //             copy: 'artwork',
    //             shipper: '',
    //             reason: '',
    //             artwork_location_id: '',
    //             artwork_packing_id: '',
    //           }
    //         })
    //         .catch((error) => {
    //           // console.log(error)
    //         })
    //       this.changeAllParts = false
    //     }

    //     this.artwork_location_log = {
    //       created_by: this.c_user.id,
    //       storage: 'in',
    //       note: '',
    //       change_date: '',
    //       copy: 'artwork',
    //       shipper: '',
    //       reason: '',
    //       artwork_location_id: '',
    //       artwork_packing_id: '',
    //     }
    //     this.$store.dispatch('loadPackings')
    //     this.$emit('getArtwork')
    //   } else {
    //     console.log('single')
    //     // ADD LOG FOR ARTWORK
    //     axios
    //       .post(`${this.$globals.apiserver}/artwork_location_logs.json`, {
    //         artwork_location_log: this.artwork_location_log,
    //       })
    //       .then((response) => {
    //         this.errors = {}
    //         this.artwork.artwork_location_logs.push(response.data)
    //         if (this.artwork_location_log.copy === 'artwork') {
    //           this.artwork.artwork_location_id =
    //             this.artwork_location_log.artwork_location_id
    //         } else if (this.artwork_location_log.copy === 'master_physical') {
    //           this.artwork.master_physical_location_id =
    //             this.artwork_location_log.artwork_location_id
    //         } else if (this.artwork_location_log.copy === 'archive_master') {
    //           this.artwork.archive_master_location_id =
    //             this.artwork_location_log.artwork_location_id
    //         } else if (this.artwork_location_log.copy === 'access_copy') {
    //           this.artwork.access_copy_location_id =
    //             this.artwork_location_log.artwork_location_id
    //         }
    //         this.$store.commit('ADD_LOG', response.data)
    //         this.active_artwork_location_logs =
    //           this.$store.state.artwork_location_logs
    //         this.showUpload = !this.showUpload
    //         this.artwork_location_log = {
    //           created_by: this.c_user.id,
    //           storage: 'in',
    //           note: '',
    //           change_date: '',
    //           copy: 'artwork',
    //           shipper: '',
    //           reason: '',
    //           artwork_location_id: '',
    //           artwork_packing_id: '',
    //         }
    //       })
    //       .catch((error) => {
    //         // console.log(error)
    //       })

    //     this.$emit('getArtwork')
    //   }
    //   this.selectedPackings = []
    //   this.editDialog = false
    //   // var aartwork_location_log = Object.keys(this.artwork_location_log).forEach(k => this.artwork_location_log[k]='')
    //   // console.log(aartwork_location_log)
    // },
    async save_artwork_location_log() {
      this.movementSaving = true
      this.movementResults = []
      this.errors = {}
      this.setupLogBasics()
      serverBus.$emit('showSnackbar', 'Saving location movement…', 'green')

      const requests = this.buildMovementRequests()
      const results = []

      for (const request of requests) {
        try {
          const response = await axios.post(
            `${this.$globals.apiserver}/artwork_location_movements.json`,
            { artwork_location_movement: request.attributes }
          )
          results.push({ ...response.data, target_label: request.label })
          this.applyConfirmedMovement(response.data)
        } catch (error) {
          const responseData = error.response && error.response.data
            ? error.response.data
            : {
                status: 'unknown',
                history: { saved: false, id: null },
                current_state: null,
                errors: { base: ['The server did not return a result. Do not retry until the stored state is checked.'] },
              }
          results.push({ ...responseData, target_label: request.label })
        }
      }

      this.movementResults = results
      this.movementSaving = false
      this.$store.dispatch('loadPackings')
      this.$emit('getArtwork')

      if (this.allMovementResultsComplete) {
        serverBus.$emit('showSnackbar', 'Location movement confirmed by the server.', 'green')
      } else {
        serverBus.$emit('showSnackbar', 'Location movement needs attention. Review the confirmed result.', 'red')
      }
    },

    setupLogBasics() {
        // Setting up basic log details
        console.log('setupLogBasics')
        this.artwork_location_log.created_by = this.c_user.id;
        this.artwork_location_log.artwork_id = this.artwork.id;
        // this.artwork_location_log.location_id = this.artwork_location_log.artwork_location_id;
        this.artwork_location_log.storage_in = this.artwork_location_log.storage === 'in' ? this.artwork_location_log.change_date : null;
        this.artwork_location_log.storage_out = this.artwork_location_log.storage !== 'in' ? this.artwork_location_log.change_date : null;
        this.artwork.artwork_location_logs = this.artwork.artwork_location_logs || [];
    },
    buildMovementRequests() {
      const base = { ...this.artwork_location_log, artwork_packing_id: null }

      if (this.artwork_location_log.copy !== 'packings') {
        return [{
          label: this.previewCopyLabel,
          attributes: base,
        }]
      }

      const requests = this.selectedPackings.map(packing => ({
        label: `${packing.colli || 'Packing'} ${packing.packing || ''}`.trim(),
        attributes: {
          ...base,
          copy: 'packings',
          artwork_packing_id: packing.id,
        },
      }))

      if (this.changeArtworkLocation) {
        requests.push({
          label: 'artwork',
          attributes: { ...base, copy: 'artwork' },
        })
      }

      return requests
    },
    applyConfirmedMovement(result) {
      if (!result || result.status !== 'complete') return

      if (result.movement) {
        this.artwork.artwork_location_logs = this.artwork.artwork_location_logs || []
        const exists = this.artwork.artwork_location_logs.some(log => log.id === result.movement.id)
        if (!exists) this.artwork.artwork_location_logs.push(result.movement)
        this.$store.commit('ADD_LOG', result.movement)
      }

      const state = result.current_state
      if (!state) return

      if (state.copy === 'packings') {
        const packing = this.artwork.artwork_packings.find(item => item.id === state.target_id)
        if (packing) {
          packing.artwork_location_id = state.location_id
          packing.location_id = state.location_id
        }
      } else {
        const fields = {
          artwork: 'artwork_location_id',
          master_physical: 'master_physical_location_id',
          archive_master: 'archive_master_location_id',
          access_copy: 'access_copy_location_id',
        }
        this.artwork[fields[state.copy]] = state.location_id
      }
    },
    movementResultError(result) {
      if (result.status === 'inconsistent') {
        return 'History and current state could not be confirmed as one consistent result. Do not repeat the movement until this result is reviewed.'
      }

      const errors = result.errors || {}
      const messages = Object.keys(errors).reduce((all, field) => {
        const fieldMessages = Array.isArray(errors[field]) ? errors[field] : [errors[field]]
        return all.concat(fieldMessages.map(message => `${field}: ${message}`))
      }, [])
      return messages.join('; ') || 'The movement was not completed.'
    },
    editMovementAfterResult() {
      this.movementResults = []
      this.saveDialog = false
    },
    startAnotherMovement() {
      this.resetStateAfterSave()
      this.movementResults = []
      this.saveDialog = false
    },
    finishMovementDialog() {
      this.resetStateAfterSave()
      this.movementResults = []
      this.saveDialog = false
      this.showUpload = false
    },
    resetStateAfterSave() {
        this.artwork_location_log = this.getDefaultLogObject();
        this.selectedPackings = [];
        this.editDialog = false;
    },

    getDefaultLogObject() {
        return {
            created_by: this.c_user.id,
            storage: 'in',
            note: '',
            change_date: '',
            copy: 'artwork',
            shipper: '',
            reason: '',
            artwork_location_id: '',
            artwork_packing_id: '',
        };
    },

    // END OF GENERATED CODE


    async save_edited_artwork_location_log() {
      this.editSaving = true
      this.editResult = null
      if (this.editedLocationLog.storage === 'in') {
        this.editedLocationLog.storage_in = this.editedLocationLog.change_date
        this.editedLocationLog.storage_out = null
      } else {
        this.editedLocationLog.storage_out = this.editedLocationLog.change_date
        this.editedLocationLog.storage_in = null
      }
      serverBus.$emit(
        'showSnackbar',
        `Saving Location History Entry…`,
        'green'
      )

      try {
        const response = await axios.put(
          `${this.$globals.apiserver}/artwork_location_logs/${this.editedLocationLog.id}.json`,
          { artwork_location_log: this.editedLocationLog }
        )
        this.editResult = response.data
        this.applyConfirmedCorrection(response.data)
        serverBus.$emit('showSnackbar', 'Location history correction confirmed.', 'green')
      } catch (error) {
        this.editResult = this.correctionErrorResponse(error)
        serverBus.$emit('showSnackbar', 'Location history correction was not completed.', 'red')
      } finally {
        this.editSaving = false
        this.$emit('getArtwork')
      }
    },
    applyConfirmedCorrection(result) {
      if (!result || result.status !== 'complete') return

      if (result.correction.action === 'updated' && result.movement) {
        this.artwork.artwork_location_logs = [
          ...this.artwork.artwork_location_logs.filter(log => log.id !== result.movement.id),
          result.movement,
        ]
        this.editedLocationLog = { ...result.movement }
        this.$store.commit('UPDATE_LOG', result.movement)
      } else if (result.correction.action === 'deleted') {
        this.artwork.artwork_location_logs = this.artwork.artwork_location_logs.filter(
          log => log.id !== result.history.id
        )
        this.$store.commit('DELETE_LOG', result.history.id)
      }

      const state = result.current_state
      if (state.copy === 'packings') {
        const packing = this.artwork.artwork_packings.find(item => item.id === state.target_id)
        if (packing) {
          packing.artwork_location_id = state.location_id
          packing.location_id = state.location_id
        }
      } else {
        const fields = {
          artwork: 'artwork_location_id',
          master_physical: 'master_physical_location_id',
          archive_master: 'archive_master_location_id',
          access_copy: 'access_copy_location_id',
        }
        this.artwork[fields[state.copy]] = state.location_id
      }
    },
    correctionErrorResponse(error) {
      return error.response && error.response.data
        ? error.response.data
        : {
            status: 'unknown',
            history: { saved: false, deleted: false, id: null },
            current_state: null,
            errors: { base: ['The server did not return a confirmed result. Reload before trying again.'] },
          }
    },
    correctionResultTitle(result) {
      if (result.status === 'complete') return 'Correction confirmed by the server.'
      if (result.status === 'rejected') return 'Correction was rejected.'
      if (result.status === 'inconsistent') return 'Stored state could not be confirmed as consistent.'
      return 'Correction result is unknown.'
    },
    correctionResultError(result) {
      const errors = result.errors || {}
      return Object.keys(errors).reduce((messages, field) => {
        const values = Array.isArray(errors[field]) ? errors[field] : [errors[field]]
        return messages.concat(values.map(value => `${field}: ${value}`))
      }, []).join('; ')
    },
    continueEditingCorrection() {
      this.editResult = null
    },
    finishEditCorrection() {
      if (this.editSaving) return
      this.editDialog = false
      this.editResult = null
      this.editedLocationLog = {}
    },
  },
}
</script>

<style scoped>
/* .activeToggle { background-color: gold; color:hotpink; } */
</style>



// WEBPACK FOOTER //
// src/components/artworks/Location.vue